export const knowledgeBase = [
  {
    keywords: ["pharma", "pharmaceutical", "medicine", "vial", "batch", "healthcare", "syrup"],
    answer: "Sahajink is ISO 9001:2015 certified for Pharmaceutical labels. We provide GMP-compliant, tamper-evident, and heat-resistant labels for medicines and vials. High precision is our guarantee."
  },
  {
    keywords: ["food", "beverage", "packaging", "grease", "water", "bottle", "edible", "oil"],
    answer: "We manufacture FDA-compliant food-grade labels. Our labels are moisture and grease resistant, perfect for packaged foods with vivid, high-impact colors."
  },
  {
    keywords: ["cosmetic", "beauty", "luxury", "foil", "uv"],
    answer: "Our cosmetic labels feature luxury finishes like metallic foils, spot UV, and soft-touch lamination. We help beauty brands elevate their packaging aesthetic."
  },
  {
    keywords: ["location", "address", "surat", "where"],
    answer: "Our manufacturing facility is located in Surat, Gujarat. We serve clients across India and export globally with reliable international shipping."
  },
  {
    keywords: ["price", "cost", "quote", "rate"],
    answer: "We offer volume-based competitive pricing. You can click the 'Get a Quote' button above, call/WhatsApp us at +91 63524 24442, or visit our [Contact Us](/contact) page and our team will get back to you with a transparent quote."
  },
  {
    keywords: ["type", "kinds", "range", "list", "variety", "what do you print", "box", "shrink", "pouch", "sleeve"],
    answer: "We offer a comprehensive range of printing solutions including:\n• Custom Label Printing (Pharma, Food, Cosmetic)\n• Printed Mono Cartons & Boxes\n• Shrink Sleeves for Bottles\n• Printed Pouches & Flexible Packaging\n• QR Code & Barcode Labels\n• Security & Tamper-Evident Labels"
  },
  {
    keywords: ["material", "adhesive", "paper", "plastic", "vinyl", "finish", "substrate", "surface"],
    answer: "We print on a wide variety of high-grade materials:\n• Chromo & Mirror Coat Paper\n• Polypropylene (PP) - Clear & White\n• PE, Vinyl, and PVC\n• Metalized Paper & Films\n• Specialty Textured Papers\n• Eco-friendly & Recyclable Options"
  },
  {
    keywords: ["qr", "barcode", "serial", "variable"],
    answer: "Yes, we specialize in Variable Data Printing (VDP) for QR codes, Barcodes, and Serial Numbers, perfect for tracking and anti-counterfeiting."
  },
  {
    keywords: ["moq", "minimum", "quantity", "small order", "how many"],
    answer: "We cater to both large-scale industrial orders and small-batch requirements. While our MOQ depends on the product type, we are known for our flexibility in supporting growing brands with low minimums."
  },
  {
    keywords: ["design", "artwork", "help", "graphics", "logo"],
    answer: "Yes! We have an in-house design team that can help you with artwork adjustment, technical layout, and ensuring your labels meet industry compliance standards."
  },
  {
    keywords: ["machine", "machinery", "technology", "equipment", "flexo", "printing press"],
    answer: "We are equipped with state-of-the-art technology, including a high-speed 10 Color Inline Flexo Machine**, ensuring premium print quality and precision for complex label designs."
  },
  {
    keywords: ["delivery", "time", "fast", "lead"],
    answer: "Our standard turnaround is 5-7 days. For urgent orders, we have an express production line that delivers in 24-48 hours."
  },
  {
    keywords: ["quality", "iso", "certified"],
    answer: "We are ISO 9001:2015 certified. We follow a multi-stage QC process with automated inspection to ensure 99.9% accuracy."
  },
  {
    keywords: ["hello", "hi", "hey"],
    answer: "Hello! I am the Sahajink AI Assistant. How can I help you with your label printing needs today?"
  }
];

export const getResponse = (query) => {
  const lowerQuery = query.toLowerCase();
  
  // 1. Check for High-Priority Keywords (Pricing/Quotes/Contact) first
  const highPriority = knowledgeBase.filter(item => 
    item.keywords.some(k => ["price", "cost", "quote", "rate", "contact", "where", "location", "address"].includes(k))
  );
  
  for (const item of highPriority) {
    if (item.keywords.some(k => lowerQuery.includes(k))) {
      return item.answer;
    }
  }

  // 2. Check for Industry Keywords
  for (const item of knowledgeBase) {
    if (item.keywords.some(k => lowerQuery.includes(k))) {
      const isGreeting = item.keywords.some(k => ["hello", "hi", "hey"].includes(k));
      if (!isGreeting && lowerQuery.includes("price")) {
        // Double check if user asked for price even if industry matched
        return knowledgeBase.find(i => i.keywords.includes("price")).answer;
      }
      return item.answer;
    }
  }

  return "I'm not sure about that, but I can connect you with our sales team! You can reach us on WhatsApp or Call at +91 63524 24442, or visit our [Contact Us](/contact) page for more details.";
};
